import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Input, InputNumber, Select, Spin } from "antd";
import { debounce } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import {
  ICreateStationeryRequestItem,
  IQueryStationeryProduct,
} from "../../models/Hrm";
import { useGetAllStationeryProduct } from "../../query/HrmQuery";

const StationeryCard = ({
  index,
  item,
  isValid,
  onChange,
  onDelete,
}: {
  index: number;
  item: Partial<ICreateStationeryRequestItem>;
  isValid: (open: boolean) => void;
  onChange: (idx: number, data: Partial<ICreateStationeryRequestItem>) => void;
  onDelete: (idx: number) => void;
}) => {
  const [filters, setFilters] = useState<IQueryStationeryProduct>({
    page: 1,
    limit: 10,
  });
  const { data, isFetching } = useGetAllStationeryProduct(filters);
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    if (data?.data) {
      if (filters.page === 1) {
        setOptions(data.data);
      } else {
        setOptions((prev) => [...prev, ...data.data]);
      }
    }
  }, [data?.data, filters.page]);

  const debouncedSearch = useMemo(
    () =>
      debounce((val: string) => {
        setFilters({ page: 1, limit: 10, name: val || undefined });
      }, 300),
    [],
  );

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (
      Math.round(target.scrollTop + target.offsetHeight) >=
        target.scrollHeight - 10 &&
      !isFetching
    ) {
      if (
        data?.pagination &&
        (filters.page || 1) * (filters.limit || 10) < data.pagination.total
      ) {
        setFilters((prev) => ({ ...prev, page: (prev.page || 1) + 1 }));
      }
    }
  };

  const handleLocalChange = (
    updates: Partial<ICreateStationeryRequestItem>,
  ) => {
    const newData = { ...item, ...updates };
    const valid =
      typeof newData.productId === "number" &&
      typeof newData.quantity === "number" &&
      newData.quantity > 0;
    isValid(valid);
    onChange(index, newData);
  };
  return (
    <Flex
      justify="space-between"
      align="center"
      gap={10}
      className="py-2 w-full"
    >
      <Select
        showSearch
        size="large"
        placeholder="Nhập tên vật phẩm"
        value={item.productId || undefined}
        onChange={(val) => handleLocalChange({ productId: Number(val) })}
        onSearch={debouncedSearch}
        onPopupScroll={handleScroll}
        filterOption={false}
        notFoundContent={
          isFetching ? <Spin size="small" /> : "Không có dữ liệu"
        }
        dropdownRender={(menu) => (
          <>
            {menu}
            {isFetching && options.length > 0 && (
              <Flex justify="center" align="center" className="py-2">
                <Spin size="small" />
              </Flex>
            )}
          </>
        )}
        options={options.map((opt) => ({
          key: opt.id,
          value: opt.id,
          label: opt.name,
        }))}
        className="w-full"
      />

      <InputNumber
        size="large"
        min={1}
        value={item.quantity}
        className="w-full"
        onChange={(value) => handleLocalChange({ quantity: value || 0 })}
      />
      <Input
        size="large"
        value={item.note}
        className="w-full"
        onChange={(e) => handleLocalChange({ note: e.target.value ?? "" })}
      />
      <DeleteOutlined
        style={{ fontSize: "25px" }}
        className="cursor-pointer text-red-500 hover:text-red-700"
        onClick={() => onDelete(index)}
      />
    </Flex>
  );
};

export default StationeryCard;
